// src/utils/fcmFingerprintStorage.js
//
// Dependency-free storage helpers for the FCM registration skip-guard
// fingerprint. Deliberately has ZERO imports beyond the platform localStorage
// so that src/utils/jwt.js (a low-level, widely-imported module) can clear
// the fingerprint from setSession() without importing src/fcmService.js —
// which pulls in firebase + apiCall and risks an import cycle back into jwt.js.
//
// src/fcmService.js re-exports these for existing call sites.

export const FCM_FINGERPRINT_STORAGE_KEY = 'fcm:lastRegistration';

// Exported so logout / session-clear paths can clear it (re-login, or a
// same-user re-login within the fingerprint TTL, must always re-register).
export const clearFCMRegistrationFingerprint = () => {
    try {
        localStorage.removeItem(FCM_FINGERPRINT_STORAGE_KEY);
    } catch (err) {
        // ignore storage errors (private mode / quota exceeded)
    }
};
